import { Controller } from "@hotwired/stimulus";
import { FontDirectUploader } from "@/utils/font_direct_uploader";

export default class extends Controller {
  static targets = ["cdnKeyField", "fileName"];
  static values = {
    cdnHost: String,
    marketFontExtId: String,
    variantWeight: String
  }

  connect() {
    this.uploader = new FontDirectUploader(this.cdnHostValue || "");
    this.updateFileStatus();
  }

  updateFileStatus() {
    // Check each file type and update UI accordingly
    this.cdnKeyFieldTargets.forEach(field => {
      const fileType = field.dataset.fileType;
      const hasFile = field.value && field.value.trim() !== '';

      if (hasFile) {
        // Update the file name display
        const fileNameTarget = this.fileNameTargets.find(
          target => target.dataset.fileType === fileType
        );
        if (fileNameTarget && fileNameTarget.textContent === "파일 선택") {
          fileNameTarget.textContent = "업로드됨";
          fileNameTarget.classList.add("text-green-600");
        }

        // Mark required files
        if (fileType === 'ttf' || fileType === 'otf') {
          const container = field.closest('.border');
          if (container) {
            container.classList.add('border-green-500');
          }
        }
      }
    });
  }

  async handleFileSelect(event) {
    const file = event.target.files[0];
    if (!file) return;

    const fileType = event.target.dataset.fileType;

    try {
      // Show uploading state
      const fileNameTarget = this.fileNameTargets.find(
        target => target.dataset.fileType === fileType
      );
      if (fileNameTarget) {
        fileNameTarget.textContent = "업로드 중...";
        fileNameTarget.classList.add("text-blue-500");
      }

      // Upload file
      const result = await this.uploader.uploadFontFile(
        file,
        this.marketFontExtIdValue,
        this.variantWeightValue
      );

      // Update hidden field
      const cdnKeyField = this.cdnKeyFieldTargets.find(
        field => field.dataset.fileType === fileType
      );
      if (cdnKeyField) {
        cdnKeyField.value = result.cdnKey;
      }

      // Update UI
      if (fileNameTarget) {
        fileNameTarget.textContent = file.name;
        fileNameTarget.classList.remove("text-blue-500");
        fileNameTarget.classList.add("text-green-600");
      }

      // Show success indicator
      const container = event.target.closest(".border");
      const successIcon = container.querySelector(".text-green-500");
      if (successIcon) {
        successIcon.classList.remove("hidden");
      }

      // Remove required indicator if file is TTF or OTF
      if (fileType === 'ttf' || fileType === 'otf') {
        const requiredIndicator = container.querySelector('.required-indicator');
        if (requiredIndicator) {
          requiredIndicator.remove();
        }
        // Update container border
        container.classList.add('border-green-500');
      }
    } catch (error) {
      console.error("Font file upload failed:", error);
      alert(`파일 업로드 실패: ${error.message}`);

      // Reset UI
      const fileNameTarget = this.fileNameTargets.find(
        target => target.dataset.fileType === fileType
      );
      if (fileNameTarget) {
        fileNameTarget.textContent = "파일 선택";
        fileNameTarget.classList.remove("text-blue-500");
      }
    }
  }
}